import Vue from 'vue'
import * as qconstants from "@/vendor/qconstants";
import {ebus} from "@/vendor/ebus";

export default {
  state: {},
  actions: {},
  mutations: {},
  getters: {
    selfServiceEnabled: (state, getters, rootState, rootGetters) => {
      return !!rootGetters.appconfig.selfServiceEnabled;
    },
    orderingEnabled: (state, getters, rootState, rootGetters) => {
      return !!rootGetters.appconfig.orderingEnabled;
    },
    takeawayOrderingEnabled: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.takeawayOrderingEnabled;
    },
    inhouseOrderingEnabled: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.inhouseOrderingEnabled;
    },
    deliveryOrderingEnabled: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.deliveryOrderingEnabled;
    },

    enableInhouseOhnePay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.inhouseOrderingEnabled && qconstants.enableInhouseOhnePay;
    },
    enableInhousePay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.inhouseOrderingEnabled && qconstants.enableInhousePay;
    },
    enableTakeawayPay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.takeawayOrderingEnabled && qconstants.enableTakeawayPay;
    },
    enableTakwawayOhnePay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.takeawayOrderingEnabled && qconstants.enableTakwawayOhnePay;
    },
    enableDeliveryOhnePay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.deliveryOrderingEnabled && qconstants.enableDeliveryOhnePay;
    },
    enableDeliveryPay: (state, getters, rootState, rootGetters) => {
      return rootGetters.appconfig.orderingEnabled && rootGetters.appconfig.deliveryOrderingEnabled && qconstants.enableDeliveryPay;
    },
  }
};
